import { put, call, takeLatest, select } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { request } from 'api';
import _ from 'lodash';

import { getFilterParams, showMessage } from 'utils/helpers';
import { TYPE, ACTION } from './actions';
import * as selectors from './selectors';

function* fetchTransactionsReportHandler() {
    try {
        const filters = yield select(selectors.filters);
        yield put(ACTION.fetchTransactionsReportLoading());

        const res = yield call(request, {
            url: 'reports/turnover',
            params: getFilterParams(filters)
        });

        if (_.size(res.data.reports)) {
            res.data.reports.push({
                automatonId: 'Сума',
                automatonName: '---',
                automaton: '---',
                cardPayed: res.data.overallCardPayed,
                cardRefill: res.data.overallCardRefilled,
                cashPayed: res.data.overallCashPayed,
                overallMoney: res.data.overallMoneyPayed,
                water: res.data.overallWater,
            });
        }

        yield put(ACTION.fetchTransactionsReportSuccess(_.get(res, 'data.reports')));
    } catch (err) {
        yield put(ACTION.fetchTransactionsReportError(err));
        console.error(err);
    }
}

function* exportToExcel() {
    try {
        const filters = yield select(selectors.filters);
        showMessage({ type: 'warning', message: 'Почалося завантаження звіту - це може зайняти деякий час.' });

        const res = yield call(request, {
            responseType: 'arraybuffer',
            url: '/reports/turnover/export',
            params: getFilterParams(filters),
        });

        const contentDisposition = _.get(res, 'headers.content-disposition', 'filename=report.xls');
        const [, filename] = contentDisposition.match(/filename=(.*)/);

        const blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' });
        FileSaver.saveAs(blob, filename);
    } catch (err) {
        console.log(err);
    }
}

export default [
    takeLatest(TYPE.FETCH_TRANSACTIONS_REPORT, fetchTransactionsReportHandler),
    takeLatest(TYPE.EXPORT_TO_EXCEL, exportToExcel),
];
